import sc from 'styled-components';
import { Typography } from 'antd';
import React from 'react';

import {
  BLUE_MED, BODY_FONT_FAMILY, CODE_FONT_FAMILY,
  HEADLINE_FONT_FAMILY, ACCENT_ORANGE, BODY_FONT_SIZE, BLACK, GRAY,
  HEADER_FONT_SIZE,
} from './styleConstants';

const { Text: Atext } = Typography;

export const PageHeader = sc.h1`
font-size: ${HEADER_FONT_SIZE};
font-family: ${HEADLINE_FONT_FAMILY};
`;

export const Header = sc.h2`
font-size: ${HEADER_FONT_SIZE};
font-family: ${HEADLINE_FONT_FAMILY};
`;

export const HeaderSub = sc.h3`
font-family: ${HEADLINE_FONT_FAMILY};
`;

export const Text = sc.p`
font-size: ${BODY_FONT_SIZE};
font-family: ${BODY_FONT_FAMILY};
`;

const HelpGray = sc.p`
font-family: ${BODY_FONT_FAMILY};
font-size: ${BODY_FONT_SIZE};
color: ${GRAY};
`;

export const HelpText = ({ type, children }) => {
  if (type) {
    return <Atext type={type} style={({ fontFamily: BODY_FONT_FAMILY, fontSize: BODY_FONT_SIZE })}>{children}</Atext>;
  }
  return <HelpGray>{children}</HelpGray>;
};

const TextAreaHeadFrame = sc.div`
  width: 100%;
  padding-top: 0.5rem;
  margin-bottom: 2px;
  justifyContent: center;
  font-family: ${BODY_FONT_FAMILY};
  font-size: ${BODY_FONT_SIZE};
`;

const TextAreaHeadContent = sc.span`
  flex: 0;
`;

export const TextAreaHead = ({ children }) => (
  <TextAreaHeadFrame>
    <TextAreaHeadContent>
      {children}
    </TextAreaHeadContent>
  </TextAreaHeadFrame>
);

export const BadWeight = sc.td`
  color: white;
  background-color: red;
  font-weight: bold;
`;

export const Duplicate = sc.td`
  background-color: rgba(255, 255,0,0.25);
  font-weight: bold;
`;

export const SoundsLike = sc.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const Code = sc.div`
  font-family: ${CODE_FONT_FAMILY};
  color: ${BLUE_MED};
  white-space: nowrap;
`;

export const CodeInline = sc.span`
  font-family: ${CODE_FONT_FAMILY};
  color: ${BLUE_MED};
  white-space: nowrap;
`;

export const List = sc.div`
display: flex;
flex-direction: row;
width: 100%;
p { flex: 1; padding-left: 4px}
`;
